import { useLocation, useParams } from "react-router-dom";
import { MyLoader } from "../../components/loaders/SkeletonLoader";
import ProductDetails from "./ProductDetails";
import { MY_ENDPOINTS } from "@raashidh/shared";
import { useFetchQuery } from "../../hooks/useQuery";
import VariantDetails from "../VariantDetails";
import MyBackButton from "../../components/MyBackButton";

interface ProductDetailsPageProps {
  product?: any;
  onClose?: () => void;
}

export default function ProductDetailsPage({ product: propProduct }: ProductDetailsPageProps) {
  const location = useLocation();
  const { id } = useParams<{ id: string }>();
  const passedProduct = location.state?.product;

  const { data: fetchedProduct, isLoading  } = useFetchQuery(
      ["productdetails", id],
      `${MY_ENDPOINTS.POS_ENDPOINTS.PUBLIC_GET_VARIANT_BY_ID.path}/${id}`,
      {
        //enabled: !id,
      }
    );


  const finalProduct = propProduct || passedProduct || fetchedProduct?.data;

  if (!finalProduct && isLoading) return <MyLoader />;
  if (!finalProduct) return <p>Error loading product</p>;

  return (
    <section className="w-full min-h-screen p-4 md:p-6 lg:p-6 lg:mt-[50px]">
      <MyBackButton />
      {/* {JSON.stringify(finalProduct,null,2)} */}
      <VariantDetails variant={finalProduct} />
    </section>
  );
}